module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "demo-layout mdl-layout mdl-layout--fixed-drawer mdl-layout--fixed-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "demo-drawer mdl-layout__drawer mdl-color--blue-grey-900 mdl-color-text--blue-grey-50",
    class: {
      'is-visible': _vm.drawerVisible
    },
    attrs: {
      "id": "main-drawer"
    }
  }, [_vm._m(1), _vm._v(" "), _c('nav', {
    staticClass: "demo-navigation mdl-navigation mdl-color--blue-grey-800"
  }, [_vm._m(2), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("people")]), _vm._v("\n          Users\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'logs'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("list")]), _vm._v("\n          Logs\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "to": {
        name: 'inputFields'
      }
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("table_chart")]), _vm._v("\n          Input Fields\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('a', {
    staticClass: "mdl-navigation__link",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("exit_to_app")]), _vm._v("Sign out")]), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('main', {
    staticClass: "mdl-layout__content mdl-color--grey-100"
  }, [_c('button', {
    staticClass: "drawer-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.showDrawer
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', [_c('router-view')], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [_c('LoginForm')], 1) : _vm._e(), _vm._v(" "), _c('overlay-component', {
    attrs: {
      "overlayModel": _vm.overlayModel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-header mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mdl-layout__header-row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "demo-drawer-header"
  }, [_c('img', {
    staticClass: "demo-avatar",
    attrs: {
      "src": "/static/images/voleadstools2_mid.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "demo-avatar-dropdown"
  }, [_c('span', [_vm._v("Control panel")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon",
    attrs: {
      "id": "accbtn"
    }
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("arrow_drop_down")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("AdTools")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("home")]), _vm._v("\n          Home\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mdl-navigation__link",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "mdl-color-text--blue-grey-400 material-icons",
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v("help_outline")]), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("Help")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c9a2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 411
// module chunks = 1